import { UiFeatureSectionModel } from "../../models";

export function mockUiFeatureSectionModel({
    id = "feature-section-1234",
    type = "uiFeatureSection",
    locale = "en",
    content = mockUiFeatureSectionModelContent()
}: Partial<UiFeatureSectionModel> = {}): UiFeatureSectionModel {
    return {
        id,
        type,
        locale,
        content
    };
}

export type UiFeatureSectionModelContent = UiFeatureSectionModel["content"];

export function mockUiFeatureSectionModelContent({
    entryTitle = "value prop block entry",
    ...optionals
}: Partial<UiFeatureSectionModelContent> = {}): UiFeatureSectionModelContent {
    return {
        entryTitle,
        ...optionals
    };
}
